<script>
import CommonStep from '@/components/common/CommonStep.vue';

export default {
  components: {
    CommonStep
  },
  data() {
    return {
      currentStep: 0, // 当前在第1步（索引从0开始）
      membershipNumber: '',
      verificationCode: '',
      newPassword: '',
      confirmPassword: '',
      showPasswordValidation: false,
      passwordValidationStatus: 'loading' // 'loading', 'success', 'error'
    };
  },
  computed: {
    canProceed() {
      if (this.currentStep === 0) {
        return this.membershipNumber.trim() !== '';
      } else if (this.currentStep === 1) {
        return this.verificationCode.trim() !== '' && 
               this.newPassword.trim() !== '' && 
               this.confirmPassword.trim() !== '' &&
               this.newPassword === this.confirmPassword;
      }
      return false;
    },
    passwordMismatch() {
      return this.currentStep === 1 && 
             this.newPassword.trim() !== '' && 
             this.confirmPassword.trim() !== '' && 
             this.newPassword !== this.confirmPassword;
    }
  },
  methods: {
    handleNext() {
      if (this.currentStep === 0 ) {
        if (!this.membershipNumber.trim()) {
          return;
        }

        console.log('提交会员号:', this.membershipNumber);
        this.currentStep++;
      } else if (this.currentStep === 1) {
        if (!this.verificationCode.trim() || !this.newPassword.trim() || !this.confirmPassword.trim()) {
          return;
        }

        console.log('提交密码设置:', {
          verificationCode: this.verificationCode,
          newPassword: this.newPassword,
          confirmPassword: this.confirmPassword
        });
        this.currentStep++;
      } else {

      }

      // 这里添加提交逻辑
      // 可以跳转到下一步或发送请求
    },
    getButtonText() {
      if (this.currentStep === 0) {
        return 'Next';
      } else if (this.currentStep === 1) {
        return 'Submit';
      } else {
        return 'Done'
      }
    },
    validatePassword() {
      this.passwordValidationStatus = 'loading';

      // 模拟密码验证过程
      setTimeout(() => {
        // 验证密码规则
        const hasSixDigits = this.newPassword.length >= 6;
        const isNotBirthdayFormat = !this.isBirthdayFormat(this.newPassword);
        const isNotSameDigits = !this.isSameDigits(this.newPassword);
        const isNotConsecutiveDigits = !this.isConsecutiveDigits(this.newPassword);
        
        const isValid = hasSixDigits && isNotBirthdayFormat && isNotSameDigits && isNotConsecutiveDigits;
        
        this.passwordValidationStatus = isValid ? 'success' : 'error';
      }, 1500);
    },
    handlePasswordBlur() {
      // 延迟隐藏，给用户时间查看验证结果
      setTimeout(() => {
        this.showPasswordValidation = false;
      }, 200);
    },
    isBirthdayFormat(password) {
      // 检查是否是生日格式 YYMMDD 或 YYYYMMDD
      if (password.length === 6) {
        // YYMMDD 格式
        const year = parseInt(password.substring(0, 2));
        const month = parseInt(password.substring(2, 4));
        const day = parseInt(password.substring(4, 6));
        
        // 检查月份是否在1-12之间
        if (month < 1 || month > 12) return false;
        
        // 检查日期是否在1-31之间
        if (day < 1 || day > 31) return false;
        
        // 检查是否是有效的日期
        const fullYear = year < 50 ? 2000 + year : 1900 + year; // 假设00-49是2000-2049，50-99是1950-1999
        const date = new Date(fullYear, month - 1, day);
        return date.getFullYear() === fullYear && 
               date.getMonth() === month - 1 && 
               date.getDate() === day;
      } else if (password.length === 8) {
        // YYYYMMDD 格式
        const year = parseInt(password.substring(0, 4));
        const month = parseInt(password.substring(4, 6));
        const day = parseInt(password.substring(6, 8));
        
        // 检查年份是否合理（1900-2100）
        if (year < 1900 || year > 2100) return false;
        
        // 检查月份是否在1-12之间
        if (month < 1 || month > 12) return false;
        
        // 检查日期是否在1-31之间
        if (day < 1 || day > 31) return false;
        
        // 检查是否是有效的日期
        const date = new Date(year, month - 1, day);
        return date.getFullYear() === year && 
               date.getMonth() === month - 1 && 
               date.getDate() === day;
      }
      
      return false;
    },
    isSameDigits(password) {
      // 检查是否是连续6个相同的数字，如111111
      return /^(\d)\1{5}$/.test(password);
    },
    isConsecutiveDigits(password) {
      // 检查是否是连续6位数字，如123456
      if (password.length < 6) return false;
      
      const digits = password.split('').map(Number);
      for (let i = 1; i < digits.length; i++) {
        if (digits[i] !== digits[i-1] + 1) {
          return false;
        }
      }
      return true;
    }
  }
};
</script>

<template>
  <div class="forgot-password">
    <div class="forgot-container">
      <CommonStep
          title="Forget Password"
          :steps="['Identity Verification', 'Setting password', 'Result']"
          :current-step-index="currentStep"
      />

      <!-- 表单内容 -->
      <div class="form-section">
        <!-- 第一步：身份验证 -->
        <div v-if="currentStep===0" class="form-item">
          <div class="form-label">
            <span class="required">*</span>
            <span class="label-text">Membership number/ID number</span>
          </div>
          <input
              type="text"
              class="form-input"
              placeholder="Please enter Membership number"
              v-model="membershipNumber"
          />
        </div>

        <!-- 第二步：设置密码 -->
        <div v-if="currentStep===1" class="step2-form">
          <!-- 联系方式和验证码 -->
          <div class="form-row">
            <div class="form-item">
              <div class="form-label">
                <span class="required">*</span>
                <span class="label-text">Contact</span>
              </div>
              <div class="contact-input-group">
                <div class="country-code">
                  <span class="code-text">+86</span>
                  <img src="@/assets/common/icon_gray_arrow_down.png" style="width: 16px;height: 16px"/>
                  <div class="divider"></div>
                </div>
                <div class="phone-input">
                  <span class="phone-text">188****6666</span>
                </div>
              </div>
            </div>

            <div class="form-item">
              <div class="form-label">
                <span class="required">*</span>
                <span class="label-text">Verification Code</span>
              </div>
              <div class="verification-input-group common-group">
                <input
                    type="text"
                    class="verification-input"
                    placeholder="Please enter the Code"
                    v-model="verificationCode"
                />
                <span class="get-code-btn">Get</span>
              </div>
            </div>
          </div>

          <!-- 新密码和确认密码 -->
          <div class="form-row">
            <div class="form-item password-form-item">
              <div class="form-label">
                <span class="required">*</span>
                <span class="label-text">New password</span>
              </div>
              <div class="password-input-group common-group">
                <input
                    type="password"
                    class="password-input"
                    placeholder="Password contains 6 digits"
                    v-model="newPassword"
                    @input="validatePassword"
                    @focus="showPasswordValidation = true"
                    @blur="handlePasswordBlur"
                />
              </div>
              
              <!-- 密码验证弹出框 -->
              <div v-if="showPasswordValidation" class="password-validation-popup">
                <div class="validation-item">
                  <div class="validation-icon">
                    <img 
                      v-if="passwordValidationStatus === 'success'" 
                      src="@/assets/common/icon_input_check_success.png" 
                      alt="success"
                    />
                    <img 
                      v-else 
                      src="@/assets/common/icon_input_loading.png" 
                      class="loading-icon"
                      alt="loading"
                    />
                  </div>
                  <span class="validation-text">Contain 6 digits</span>
                </div>
                
                <div class="validation-item">
                  <div class="validation-icon">
                    <img 
                      v-if="passwordValidationStatus === 'success'" 
                      src="@/assets/common/icon_input_check_success.png" 
                      alt="success"
                    />
                    <img 
                      v-else 
                      src="@/assets/common/icon_input_loading.png" 
                      class="loading-icon"
                      alt="loading"
                    />
                  </div>
                  <span class="validation-text">Cannot use the last 6 digits of your birthday, the same 6 digits, or 6 consecutive digits.</span>
                </div>
              </div>
            </div>

            <div class="form-item">
              <div class="form-label">
                <span class="required">*</span>
                <span class="label-text">Confirm New password</span>
              </div>
              <div class="password-input-group common-group">
                <input
                    type="password"
                    class="password-input"
                    placeholder="Please enter the password again"
                    v-model="confirmPassword"
                />
              </div>
              <div v-if="passwordMismatch" class="error-message">
                The passwords entered do not match
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 提交按钮 -->
      <div class="submit-section">
        <button
            class="submit-button"
            :class="{ 'disabled': !canProceed }"
            :disabled="!canProceed"
            @click="handleNext"
        >
          {{ getButtonText() }}
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.forgot-password {
  background: #ffffff;
  padding: 40px 0;
  display: flex;
  justify-content: center;
}

.forgot-container {
  width: 1120px;
  min-width: 1120px;
  background: #FFFFFF;
  border-radius: 8px;
  padding: 40px 0;
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 40px;
}

.form-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 352px;
  height: 72px;
  padding: 12px 0;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 4px;

  .required {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 12px;
    line-height: 1.67em;
    color: #D8000F;
  }

  .label-text {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 12px;
    line-height: 1.67em;
    color: #808080;
  }
}

.form-input {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5em;
  color: #333333;
  border: none;
  outline: none;
  background: transparent;
  width: 100%;

  &::placeholder {
    color: #BFBFBF;
  }
}

// 第二步表单样式
.step2-form {
  display: flex;
  flex-direction: column;
  gap: 36px;
}

.form-row {
  display: flex;
  gap: 32px;
}

.contact-input-group {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 352px;
}

.country-code {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #ECEEF0;
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  padding: 8px 12px;

  .code-text {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 16px;
    line-height: 1.5em;
    color: #BFBFBF;
    width: 34px;
  }

  .dropdown-icon {
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFF;
    border-radius: 2px;
  }

  .divider {
    width: 0.5px;
    height: 12px;
    background: #D9D9D9;
  }
}

.phone-input {
  flex: 1;
  background: #ECEEF0;
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  padding: 8px 12px;

  .phone-text {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 16px;
    line-height: 1.5em;
    color: #BFBFBF;
  }
}

.verification-input-group {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 352px;

  .verification-input {
    flex: 1;
    height: 40px;
    padding: 8px 12px;
    border: none;
    border-radius: 0;
    background: #FFFFFF;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 16px;
    line-height: 1.5em;
    color: #333333;
    outline: none;

    &::placeholder {
      color: #BFBFBF;
    }
  }

  .get-code-btn {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 16px;
    line-height: 1.5em;
    color: #D8000F;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
      text-decoration: underline;
    }
  }
}

.password-input-group {
  width: 352px;

  .password-input {
    width: 100%;
    height: 40px;
    padding: 8px 12px;
    border: none;
    border-radius: 0;
    background: #FFFFFF;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 16px;
    line-height: 1.5em;
    color: #333333;
    outline: none;

    &::placeholder {
      color: #BFBFBF;
    }
  }
}

.common-group {
  border-bottom: 1px solid #ECEEF0;
}

.error-message {
  font-family: PingFang SC;
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #D8000F;
  margin-top: 4px;
}

.password-form-item {
  position: relative;
}

.password-validation-popup {
  position: absolute;
  top: 100%;
  left: 0;
  width: 352px;
  background: #FFFFFF;
  border: 1px solid #ECEEF0;
  border-radius: 4px;
  box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.04);
  padding: 20px 16px;
  z-index: 1000;
  margin-top: 4px;
}

.validation-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.validation-icon {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  
  img {
    width: 14px;
    height: 14px;
  }
}

.loading-icon {
  animation: rotate 1s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.validation-text {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.67em;
  color: #808080;
  flex: 1;
}


.submit-section {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 60px;
}

.submit-button {
  width: 256px;
  height: 64px;
  background: #D8000F;
  border: none;
  border-radius: 6px;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.44em;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover:not(.disabled) {
    background: #D8000F;
  }

  &.disabled {
    background: #FFC5C4;
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:active:not(.disabled) {
    transform: scale(0.98);
  }
}

</style>